/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

export const styles:any[] = ['[data-hidden="true"][_ngcontent-%COMP%] {\r\n    display: none !important;\r\n}'];


// WEBPACK FOOTER //
// ./$$_gendir/src/app/document-hitlist/components/document-hitlist.component.css.shim.ngstyle.ts